<template>
  <el-container class="classManger" id="print">
    <el-aside class="sidebar">
      <!-- <el-button
        type="text"
        style="float:right;margin-top:5px;margin-right:10px"
        @click="openCampusDialog(1)"
        icon="el-icon-plus"
      >添加省份</el-button>
      <div class="title">校区树</div>-->
      <div class="campusManage-search">
        <el-tree :data="ChapterTree" :props="ChapterProps" :default-expanded-keys="[chapterForm.id]" :highlight-current="true" :expand-on-click-node="false" class="research-tree" ref="tree" node-key="id" current-node-key>
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span :title="data.name" @click="choseChapterId(data,node);">{{ data.name }}</span>
          </span>
        </el-tree>
      </div>
    </el-aside>
    <el-main class="sidebarRight">
      <el-card>
        <el-form ref="addPhotoForm" :model="addPhotoForm">
          <el-row :gutter="20" style="height:60px;">
            <el-col :sm="10" :md="5" :lg="3">
              <el-button type="primary" @click.stop="addAttachmentPhoto()">上传模板</el-button>
            </el-col>
            <el-col :sm="10" :md="5" :lg="3">
              <el-button @click="previewCert">打印预览</el-button>
            </el-col>
          </el-row>
        </el-form>
        <vue-easy-print table-show ref="easyPrint" v-if="certificatePic">
          <img :src="canvasImgSrc" class="certificatePic" />
        </vue-easy-print>
        <div v-else class="tips">暂未上传</div>
        <div style="clear:both;"></div>
      </el-card>
    </el-main>
    <el-dialog title="添加模板素材中心" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
      <!-- <photoMaterial  @attachmentSizeChange="getAttachmentByType()"></photoMaterial> -->
      <photoMaterial @attachmentIDChange="attachmentIDChange"></photoMaterial>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.stop="uploadPic">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import vueEasyPrint from "vue-easy-print";
import { uploadTC } from "../../upload/tecent";
import axios from "axios";
import { uploadOSS } from "../../upload/upload";
import photoMaterial from "../materialCenter/photoMaterial.vue";
export default {
  components: { photoMaterial, vueEasyPrint },
  data () {
    return {
      mousemoveShow: "",
      addCampusName: "添加省份",
      editCampusName: "编辑部门",
      campusLableName: "",
      shortName: "",
      showAbbreviationName: false,
      id: "", //校区id
      showEditorDialog: false,
      showAddDialog: false,
      loading: true, //表格是否加载中
      inp: "", //输入框绑定的值
      defaultProps: {
        children: "list",
        label: "name"
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      campusShow: false,
      NodeClick: true,
      form: {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: ""
      },
      ChapterTree: [],
      ChapterProps: {
        children: "children",
        label: "name"
      },
      chapterForm: {
        id: 0,
        type: 1,
        courseId: null
      },
      addCampusForm: {
        parentId: "",
        name: "",
        active: 1,
        level: 1,
        shortName: ""
      },
      editCampusForm: {
        campusId: "",
        shortName: ""
      },
      addCampusDialog: false,
      editCampusDialog: false,
      CampusTreeData: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
        checkStrictly: true
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入教室名称",
            trigger: "blur"
          }
        ],
        parentId: [
          {
            required: true,
            message: "请选择校区",
            trigger: "change"
          }
        ],
        active: [
          {
            required: true,
            message: "请选择是否禁用",
            trigger: "change"
          }
        ]
      },
      addwidth: "30%",
      campusList: [],
      campusId: null,
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10
        },
        {
          value: 20,
          label: 20
        }
      ],
      total: 0,
      courseID: {
        subjectId: "1262553455881359362"
      },
      addAttachmentPhotoBlock: false,
      updateAttachmentBlock: false,
      updateFodderGroupInfoBlock: false,
      loading: false,
      id: null,
      ids: [],
      fodderGroupInfoName: name,
      fodderGroupInfoId: null,
      addPhotoForm: {
        id: null,
        attachmentList: []
      },
      uploadPictures: {
        objectId: "",
        attachmentId: "",
        type: 5
      },
      dialogVisible: false,
      arrID: [],
      canvasImgSrc: '',
      certificatePic: ""
    };
  },
  methods: {
    previewCert () {
      this.$nextTick(() => {
        console.log(this.certificatePic)
        this.$refs.easyPrint.print();
      })
    },
    choseChapterId (value, index) {
      this.courseID.subjectId = value.id;
      this.getSubjectCourseCertPaper(this.courseID);
    },
    sizeChange () {
      this.pageChange();
    },
    currentChange () {
      this.pageChange();
    },
    pageChange () {
      //分页发生变化时
      let data;
      if (this.inp && !this.campusId) {
        data = {
          pageNmuber: this.currentPage,
          pageSize: this.pageSize,
          name: this.inp,
          campusId: this.campusId
        };
      } else {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          name: this.inp,
          campusId: this.campusId
        };
      }
      this.api.campus.pageList(data).then(result => {
        if (result.success) {
          this.loading = false;
          this.tableData = result.data.records;
        }
      });
    },
    paginationInit () {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (umx.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
    },
    updateClassroom () {
      this.$refs.updateForm.validate(val => {
        if (val) {
          let form = {};
          Object.assign(form, this.form, { id: this.id });
          this.api.classroom.updateClassroom(form).then(result => {
            if (result.success) {
              this.showEditorDialog = false;
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.$message.success(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    isActive (v) {
      //是否启用
      let data = {
        id: v.id,
        active: v.active == "1" ? "1" : "-1"
      };
      this.api.campus.active(data).then(result => {
        if (result.success) {
          this.$message.success(result.message);
          this.getPageList();
        } else {
          this.$message.error(result.message);
          this.getPageList();
        }
      });
    },
    del (v) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(result => {
          this.api.classroom.deleteClassroom([{ id: v.id }]).then(result => {
            if (result.success) {
              this.showEditorDialog = false;
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.$message.success(result.message);
            }
          });
        })
        .catch(() => { });
    },
    getCampusTree () {
      this.api.campus.getCampusTree({ parentId: 1 }).then(res => {
        this.CampusTreeData = res.data;
        if (this.CampusTreeData.length === 0) {
          this.loading = false;
          this.$message.error("暂无校区，请添加校区");
        }
        let data = this.CampusTreeData[0];
        if (data.children.length > 0) {
          this.campusId = data.id;
          this.getPageList();
          let item = data.children[0];
          if (item.children.length > 0) {
            let items = item.children[0];
            if (items.children.length > 0) {
              let itemss = items.children[0];
              if (itemss.children.length > 0) {
              } else {
                this.form.campusId =
                  data.children[0].children[0].children[0].id;
                // this.campusId = data.children[0].children[0].children[0].id;
                // this.getPageList();
              }
            } else {
              this.form.campusId = data.children[0].children[0].id;
              // this.campusId = data.children[0].children[0].id;
              // this.getPageList();
            }
          } else {
            this.form.campusId = data.children[0].id;
            // this.campusId = data.children[0].id;
            // this.getPageList();
          }
        } else {
          this.form.campusId = data.id;
          this.campusId = data.id;
          this.getPageList();
        }
        this.$nextTick(function () {
          this.$refs.tree.setCurrentKey(this.campusId);
        });
      })
        .catch(error => { });
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleNodeClick (data) {
      if (this.NodeClick == true) {
        if (data.children.length > 0) {
          let item = data.children[0];
          if (item.children.length > 0) {
            let items = item.children[0];
            if (items.children.length > 0) {
              this.addCampusForm.parentId = data.children[0].children[0].id;
            } else {
              this.addCampusForm.parentId = data.children[0].children[0].id;
            }
          } else {
            this.addCampusForm.parentId = data.children[0].id;
          }
        } else {
          this.addCampusForm.parentId = data.id;
        }
        this.campusId = data.id;
        this.getPageList();
      }
    },
    openCampusDialog (level, id) {
      if (level) {
        if (level === 1) {
          this.addCampusName = "添加省份";
          this.campusLableName = "省份名称";
          this.shortName = "省份简称";
          this.showAbbreviationName = true;
        }
        if (level === 2) {
          this.addCampusName = "添加城市";
          this.campusLableName = "城市名称";
          this.shortName = "城市简称";
          this.showAbbreviationName = true;
        }
        if (level === 3) {
          this.addCampusName = "添加校区";
          this.campusLableName = "校区名称";
          this.shortName = "校区简称";
          this.showAbbreviationName = true;
        }
        if (level === 4) {
          this.addCampusName = "添加部门";
          this.campusLableName = "部门名称";
          this.showAbbreviationName = false;
        }
        if (level !== 4) {
          this.addCampusForm.level = level;
        }
      } else {
        this.addCampusForm.level = 1;
      }
      if (id) {
        this.addCampusForm.parentId = id;
      } else {
        this.addCampusForm.parentId = "";
      }
      this.addCampusDialog = true;
    },
    openEditCampusDialog (level, data) {
      if (level === 1) {
        this.editCampusName = "编辑省份";
        this.campusLableName = "省份名称";
        this.shortName = "省份简称";
        this.showAbbreviationName = true;
      }
      if (level === 2) {
        this.editCampusName = "编辑城市";
        this.campusLableName = "城市名称";
        this.shortName = "城市简称";
        this.showAbbreviationName = true;
      }
      if (level === 3) {
        this.editCampusName = "编辑校区";
        this.campusLableName = "校区名称";
        this.shortName = "校区简称";
        this.showAbbreviationName = true;
      }
      if (level === 4) {
        this.editCampusName = "编辑部门";
        this.campusLableName = "部门名称";
        this.showAbbreviationName = false;
      }
      this.editCampusForm.id = data.id;
      this.getCampus(data.id);
      this.editCampusDialog = true;
    },
    getCampus (data) {
      this.api.campus.getCampus({ id: data }).then(result => {
        if (result.success) {
          this.editCampusForm = result.data;
          if (this.editCampusForm.parentId === "1") {
            this.editCampusForm.parentId = "";
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    addCampus () {
      this.$refs.addCampusForm.validate(val => {
        if (val) {
          if (typeof this.addCampusForm.parentId == "object") {
            let index = this.addCampusForm.parentId.length;
            this.addCampusForm.parentId = this.addCampusForm.parentId[
              index - 1
            ];
          }
          if (this.campusShow == true) {
            this.addCampusForm.level = 4;
          }
          this.api.campus.addCampus(this.addCampusForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.addCampusDialog = false;
              this.campusShow = false;
              this.showAbbreviationName = false;
              this.getCampusTree();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    updateCampus () {
      this.$refs.editCampusForm.validate(val => {
        if (val) {
          if (typeof this.editCampusForm.parentId == "object") {
            let index = this.editCampusForm.parentId.length;
            this.editCampusForm.parentId = this.editCampusForm.parentId[
              index - 1
            ];
          }
          this.api.campus.updateCampus(this.editCampusForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.editCampusDialog = false;
              this.campusShow = false;
              this.getCampusTree();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    deleteCampus (id, level) {
      let name = "";
      if (level === 1) {
        name = "省份（关联子校区）";
      }
      if (level === 2) {
        name = "城市（关联子校区）";
      }
      if (level === 3) {
        name = "校区";
      }
      if (level === 4) {
        name = "部门";
      }
      this.$confirm("将会删除此" + name + "，是否确认删除？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.campus.deleteCampus([{ id: id }]).then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.getCampusTree();
            this.NodeClick = true;
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    getPageList () {
      this.loading = true;
      let data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        name: this.inp,
        campusId: this.campusId
      };
      this.loading = true;
      this.api.campus.pageList(data).then(result => {
        if (result.success) {
          this.tableData = result.data.records;
          this.total = Number(result.data.total);
          this.loading = false;
          this.paginationInit();
        }
      });
    },
    // setIdEvent(val) {
    //   this.campusId = val.id;
    //   this .pageSize = 10;
    //   this.currentPage = 1;
    //   this.inp = "";
    //   var data = {
    //     pageNumber: this.currentPage,
    //     pageSize: this.pageSize,
    //     sortName: "create_time",
    //     sortOrder: "desc",
    //     campusId: val.id
    //   };
    //   this.api.classroom.pageList(data).then(result => {
    //     // console.log(result)
    //     if (result.success) {
    //       this.tableData = result.data.records;
    //     }
    //   });
    // },
    // getCampusTree() {
    //   this.api.campus
    //     .getCampusTree({parentId:1})
    //     .then(res => {
    //       this.CampusTreeData = res.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    setaddDialogwidth () {
      //设置添加老师弹窗大小
      var width = document.body.clientWidth;
      if (width < 560) {
        this.addwidth = "80%";
      } else if (width < 790) {
        this.addwidth = "70%";
      } else if (width < 970) {
        this.addwidth = "50%";
      } else if (width < 1300) {
        this.addwidth = "40%";
      } else {
        this.addwidth = "30%";
      }
    },
    clearForm () {
      this.form = {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: ""
      };
    },
    clearAddCampusForm () {
      this.addCampusForm.name = "";
      this.addCampusForm.parentId = "";
      this.addCampusForm.active = 1;
      this.showAbbreviationName = false;
    },
    clearEditCampusForm () {
      this.editCampusForm.name = "";
      this.editCampusForm.parentId = "";
      this.editCampusForm.active = 1;
    },
    addClassRoom () {
      this.$refs.addForm.validate(val => {
        if (val) {
          this.api.classroom.addClassroom(this.form).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.getPageList();
              this.clearForm();
              this.showAddDialog = false;
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    //获取课程
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  if (items.children) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.ChapterTree = result.data;
            this.courseID.subjectId = result.data[0].children[0].children[0].id;
            // this.subjectId = result.data[0].children[0].children[0].id;
            // this.searchForm.courseId = this.ChapterTree[0].children[0].children[0].id;
            // console.log(this.searchForm.courseId)
            // this.chapterForm.courseId = this.ChapterTree[0].children[0].children[0].id;
            // console.log(this.chapterForm.courseId)
            // this.getTree();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //默认获取证书模板
    getSubjectCourseCertPaper (data) {
      console.log('获取url', data)
      this.certificatePic = ''
      this.canvasImgSrc = ''
      this.api.getSubjectCourseCertPaper(data).then(res => {
        this.loading = false;
        console.log(res);
        this.certificatePic = res.data.url;
        this.fnDraw(res.data)
      }).catch(error => {
        this.certificatePic = '';
        console.warn(error)
      })
    },
    loadPng (src, callback) {
      let avatar = src
      let img = new Image()
      img.crossOrigin = '*'
      img.src = avatar
      img.onload = () => {
        callback && callback(img)
      }
    },
    fnDraw (obj) {
      const that = this
      console.log(obj, 'fnDraw')
      const oC = document.createElement('canvas')
      const gd = oC.getContext('2d')
      oC.width = 880
      oC.height = 642
      // 绘制背景图
      this.loadPng(this.certificatePic, certSrc => {
        gd.drawImage(
          certSrc, 0, 0, 880, 642
        )
        // 绘制标题
        gd.font = 'normal normal 400 24px SourceHanSerifCN'
        gd.fillStyle = '#1D2225'
        gd.textAlign = 'left'
        gd.fillText(obj.name, 210, 355)
        gd.fillText(obj.card, 210, 395)
        gd.fillText(obj.name, 210, 435)
        gd.fillText(obj.name, 210, 475)
        gd.fillText(obj.name, 210, 515)
        gd.fillText(obj.name, 210, 555)
        const oUrl = oC.toDataURL('image/jpeg', 1)
        const oImg = new Image()
        oImg.src = oUrl
        oImg.onload = function () {
          that.canvasImgSrc = oImg.src
        }
      })
    },
    //上传模板
    addAttachmentPhoto () {
      this.dialogVisible = true;
    },
    handleClose () {
      this.dialogVisible = false;
    },
    attachmentIDChange (data) {
      console.log(data);
      this.arrID = data;
    },
    uploadPic () {
      if (this.arrID.length > 1) {
        this.$message({
          showClose: true,
          message: "请选择一张证书!",
          type: "warning"
        });
      } else {
        var s = this.arrID[0].id;
        this.uploadPictures.objectId = this.courseID.subjectId;
        this.uploadPictures.attachmentId = s;
        this.api.getSubjectUploadCourseCertPaper(this.uploadPictures).then(result => {
          if (result.code == 200) {
            this.dialogVisible = false;
            this.getSubjectCourseCertPaper(this.courseID);
            this.$message({
              showClose: true,
              message: "上传模板成功",
              type: "success"
            });
          }
        })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  watch: {
    addCampusDialog: function (newVal) {
      if (!newVal) {
        this.campusShow = false;
        this.$refs.addCampusForm.resetFields();
        this.addCampusForm.parentId = "";
        this.addCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
    editCampusDialog: function (newVal) {
      if (!newVal) {
        this.campusShow = false;
        this.$refs.editCampusForm.resetFields();
        this.editCampusForm.parentId = "";
        this.editCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    }
  },
  created () {
    this.getCampusTree();
  },
  mounted () {
    window.onresize = () => {
      this.setaddDialogwidth();
    };
    this.getSubjectTreeList();
    this.getSubjectCourseCertPaper(this.courseID);
  }
};
</script>
<style scoped>
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}
.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}
.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}
.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.certificatePic {
  width: 880px;
  height: 642px;
}
.legend_pic {
  display: flex;
}
.tips {
  text-align: center;
  margin: 0.35rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/campusManger.vue